var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"error-404"},[_c('p',{staticClass:"error-404__text"},[_vm._v("Запрашиваемая вами страница не найдена 😿")])])}]

export { render, staticRenderFns }